export const structure = {
  tree: [],
  map: {},
  activeLayers: [],
  fields: {},
  isSelectDisabled: false,
  layerNames: {},
  layerTypes: {},
  objectsCount: {},
  filteredObjectsCount: {},
  fullDataSetLoaded: {}
}

export const nonClearableFields = ['activeLayers', 'map']
